import { useEffect, useState, PropsWithChildren } from 'react';
import { Views, mobileBreakpoint } from '~/utilities';
import { ViewContext } from './ViewContext';

export const ViewProvider = ({ children }: PropsWithChildren) => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < mobileBreakpoint
  );
  const [view, setView] = useState(isMobile ? Views.List : Views.Both);

  const handleResize = () => {
    const newIsMobile = window.innerWidth < mobileBreakpoint;
    setIsMobile(newIsMobile);
    setView(newIsMobile ? Views.List : Views.Both);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const value = {
    view,
    isMobile,
    handleViewChange: setView,
  };

  return <ViewContext.Provider value={value}>{children}</ViewContext.Provider>;
};
